
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/gmarket/detail.m",
      function () {
        return require("private-next-pages/partners/gmarket/detail.m.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/gmarket/detail.m"])
      });
    }
  